import * as React from 'react';
import SiteLicense from './SiteLicense/SiteLicense';

export default class LicenseContainerComponent extends React.Component<any, any> {
  render() {
    return (
      <SiteLicense />
    );
  }

  componentDidMount() {
    document.getElementById('app')!.classList.add('background-style');
  }

  componentWillUnmount() {
    document.getElementById('app')!.classList.remove('background-style');
  }
}
